<template>
  <div id="showInframe" tabindex="-1" @keyup.esc="$parent.showIframe=false">
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="$parent.showIframe=false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <iframe
              :src="`https://www.youtube.com/embed/${$parent.obtenerV(url)}`"
              frameborder="0"
              width="600"
              height="500"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "showFrame",
  props: { url: String }
};
</script>
<style>
#showInframe .modal-dialog {
    max-width: 700px;
}
</style>